import React from 'react';
import { getRoundById } from 'general/js/helpers';
import ArrayHelper from 'foundation/array-helper';
import CustomEventLeaderboardNameColumn from './custom-event-leaderboard-name-column';
import CustomEventLeaderboardPlayersColumn from './custom-event-leaderboard-players-column';
import CustomEventLeaderboardScoreToParColumn from './custom-event-leaderboard-score-to-par-column';
import CustomEventLeaderboardHoleByHoleWidget from './custom-event-leaderboard-hole-by-hole-widget';
import CustomEventLeaderboardPositionColumn from './custom-event-leaderboard-position-column';
import CustomEventLeaderboardTeeTimeGroup from './custom-event-leaderboard-tee-time-group';
import CustomEventLeaderboardHoleColumn from './custom-event-leaderboard-hole-column';
import { SitecoreImageField } from 'components/sitecore-fields';

const CustomEventLeaderboardRows = (
    {
        options,
        currentRound,
        players,
    }
) => {
    const renderRows = (playersList) => {
        return playersList.map((player) => {
            const scoringPlayerRound = getRoundById(player.rounds, currentRound);
            const playerSitecoreData = player.sitecoreData;
            const isChampion = (playerSitecoreData !== null && playerSitecoreData !== undefined) ? playerSitecoreData.isChampion : false;

            return (
                <div className='custom-event-leaderboard__item' key={player.id}>                    
                    <div className='custom-event-leaderboard__alphalist'>
                        {
                            isChampion &&
                            <div className='custom-event-leaderboard__is-champion'>
                                <SitecoreImageField img={options.customEventLeaderboardDatasource.championConfiguration.championBackgroundImage} />
                            </div>
                        }
                        <CustomEventLeaderboardPositionColumn playerPosition={player.position} />
                        <CustomEventLeaderboardNameColumn options={options.customEventLeaderboardDatasource} player={playerSitecoreData} />
                        {
                            options.customEventLeaderboardDatasource.isTeamEvent &&
                            <div className="custom-event-leaderboard__player-list">
                                <CustomEventLeaderboardPlayersColumn playersList={playerSitecoreData} />
                            </div>
                        }
                        <CustomEventLeaderboardTeeTimeGroup scoringPlayerRound={scoringPlayerRound} />
                    </div>
                    <div className='custom-event-leaderboard__score-card'>
                        {
                            (options.customEventLeaderboardHolesToBePlayed !== null && !ArrayHelper.isEmpty(options.customEventLeaderboardHolesToBePlayed)) &&
                            <CustomEventLeaderboardHoleByHoleWidget
                                holesToBePlayed={options.customEventLeaderboardHolesToBePlayed}
                                isScrollable={true}
                                scoringPlayerRound={scoringPlayerRound}
                                playerSitecoreData={playerSitecoreData}
                            ></CustomEventLeaderboardHoleByHoleWidget>
                        }
                        <CustomEventLeaderboardScoreToParColumn playerScoreToPar={player.toPar} />
                        <CustomEventLeaderboardHoleColumn playerHole={player.hole} />
                        {
                            isChampion &&
                            <div className='custom-event-leaderboard__is-champion-label'>{options.customEventLeaderboardDatasource.championConfiguration.championLabel}</div>
                        }
                    </div>
                </div>
            );
        });
    };

    return (
        <React.Fragment>
            {renderRows(players)}
        </React.Fragment>
    );
};

export default CustomEventLeaderboardRows;
